const DEFAULT_CONFIG = {
	menuItemsSelector: '.js-hotel-nav-item',
	menuItemsAttr: 'data-id',
	blocksSelector: '.js-hotel-block',
	blocksAttr: 'data-id',
}

export default class ScrollNavigation {
	#config

	constructor(config) {
		this.#config = { ...DEFAULT_CONFIG, ...config }

		this.menuItems = []
		this.blocks = []
		this.activeMenuItem

		// Елементи бокового меню можуть активуватись у двох випадках:
		// 1. при кліку на пункт меню
		// 2. під час скролу, у відповідності із блоком у viewport-і ( window.addEventListener('scroll' => {}) )
		// якщо клікнути по пункту меню (1) починається скролл до відповідного блоку,
		// відповідно спрацьовує також (2) і переключаються пункти активного меню

		// this.scrollInProgress на час скролу після кліку по пункту меню
		// встановлюється як true для уникнення переключень активних пунктів меню
		this.scrollInProgress = false

		this._initMenuItems(this.#config.menuItemsSelector)
		this._initBlocks(this.#config.blocksSelector)

		// Check if elements exist
		if (!this.menuItems.length || !this.blocks.length) return

		// Set default active
		this.activeMenuItem = this.menuItems[0]
		this._activateMenuItem()

		this._initEvents()
	}

	_initMenuItems(selectorOrElements) {
		const menuItemsNodes =
			typeof selectorOrElements === 'string'
				? [...document.querySelectorAll(selectorOrElements)]
				: selectorOrElements

		if (!menuItemsNodes) return

		this.menuItems = menuItemsNodes.map(menuItemNode => {
			return {
				htmlElement: menuItemNode,
				id: menuItemNode.getAttribute(this.#config.menuItemsAttr),
			}
		})
	}

	_activateMenuItem() {
		this._deactivateMenuItems()
		this.activeMenuItem.htmlElement.classList.add('is-active')
	}

	_deactivateMenuItems = () => {
		this.menuItems.forEach(menuItem =>
			menuItem.htmlElement.classList.remove('is-active')
		)
	}

	_getMenuItemByID(id) {
		return this.menuItems.find(menuItem => id === menuItem.id)
	}

	_initBlocks(selectorOrElements) {
		const blocksNodes =
			typeof selectorOrElements === 'string'
				? [...document.querySelectorAll(selectorOrElements)]
				: selectorOrElements

		if (!blocksNodes) return

		this.blocks = blocksNodes.map(blockNode => {
			return {
				htmlElement: blockNode,
				id: blockNode.getAttribute(this.#config.blocksAttr),
				position:
					blockNode.getBoundingClientRect().top +
					document.documentElement.scrollTop,
			}
		})
	}

	_initEvents() {
		window.addEventListener('scroll', () => {
			if (this.scrollInProgress) return

			const currentWindowPositon = window.pageYOffset + window.innerHeight / 2
			const blocksWithLessPosition = this.blocks.filter(
				block => block.position <= currentWindowPositon
			)

			if (!blocksWithLessPosition.length) return

			const closestBlock =
				blocksWithLessPosition[blocksWithLessPosition.length - 1]
			if (closestBlock.id !== this.activeMenuItem.id) {
				this.activeMenuItem = this._getMenuItemByID(closestBlock.id)
				this._activateMenuItem()
			}
		})

		window.addEventListener('resize', () =>
			this._recalculateBlocksPosition.bind(this)
		)

		// Click on menu
		this.menuItems.forEach(menuItem => {
			menuItem.htmlElement.addEventListener('click', () => {
				if (this.activeMenuItem.id === menuItem) return
				this.activeMenuItem = menuItem

				// Menus manipulation
				this._activateMenuItem()

				// Blocks manipulation
				this._activateBlock(menuItem.id)
			})
		})
	}

	_activateBlock(id) {
		const activeBlock = this._getBlockByID(id)

		this.scrollInProgress = true
		activeBlock.htmlElement.scrollIntoView({ behavior: 'smooth' })

		// scrollIntoView() поки не приймає callback функцію, тому як шкидкий костиль працює через setTimeout
		// TODO: випилити setTimeout()
		setTimeout(() => (this.scrollInProgress = false), 1000)
	}

	_getBlockByID(id) {
		return this.blocks.find(block => id === block.id)
	}

	_recalculateBlocksPosition() {
		this.blocks.forEach(
			block =>
				(block.position =
					block.htmlElement.getBoundingClientRect().top +
					document.documentElement.scrollTop)
		)
	}
}
